import React from 'react'
import { Headline } from '../../../index'
import { useIntl } from 'react-intl'
import { getTotalCustomerCreditUsedInItems } from '@utils/basketUtils'
import {
  OrderSummaryTotals,
  OrderSummaryCategoryList
} from './OrderSummary.partials'

import * as S from './OrderSummary.styles'
import * as T from './OrderSummary.types'

const OrderSummary = ({
  basket,
  showShipment = true,
  showProducts = true,
  className = ''
}: T.OrderSummaryProps) => {
  const { formatMessage } = useIntl()

  if (!basket) {
    return <></>
  }

  const {
    orderTotal,
    itemTotal,
    itemSubTotal,
    currency,
    shippingItems,
    c_categories = [],
    c_groupedByCategories,
    c_giftCertificateTotal,
    getProductAvailability,
    giftCertificateItems
  } = basket

  let itemSubTotalWithoutCredit: number = itemSubTotal
  let itemTotalWithoutCredit: number = itemTotal
  let totalCreditUsedInItems = 0

  if (basket?.c_customerCreditUsed) {
    totalCreditUsedInItems = getTotalCustomerCreditUsedInItems(basket)
    itemSubTotalWithoutCredit += totalCreditUsedInItems
    itemTotalWithoutCredit += totalCreditUsedInItems
  }

  return (
    <div className={className}>
      <Headline tag='h2' className='headline-h5 mb-3'>
        {formatMessage({
          defaultMessage: 'Order Overview',
          id: 'msp.checkout.ordersummary'
        })}
      </Headline>
      <OrderSummaryTotals
        showShipment={showShipment}
        currency={currency}
        orderTotal={orderTotal}
        productTotal={itemTotalWithoutCredit}
        productSubTotal={itemSubTotalWithoutCredit}
        shippingItems={shippingItems}
        customerCreditUsed={totalCreditUsedInItems}
        giftCertificateTotal={c_giftCertificateTotal}
      />
      {showProducts && (
        <>
          <div className={S.CheckoutItemsWrapper}>
            <OrderSummaryCategoryList
              currency={currency}
              categoryList={c_categories}
              giftCertificateItems={giftCertificateItems}
              getProductAvailability={getProductAvailability}
              c_groupedByCategories={c_groupedByCategories}
            />
          </div>
          <div className={S.BigBlackBorder}></div>
          <div className={S.ThinBlackBorder}></div>
          <OrderSummaryTotals
            showShipment={showShipment}
            currency={currency}
            orderTotal={orderTotal}
            productTotal={itemTotalWithoutCredit}
            productSubTotal={itemSubTotalWithoutCredit}
            shippingItems={shippingItems}
            customerCreditUsed={totalCreditUsedInItems}
            giftCertificateTotal={c_giftCertificateTotal}
          />
        </>
      )}
    </div>
  )
}

export default OrderSummary
